import React, { useState, useEffect } from "react";
// import { Link } from "found";

import SvgCloseIcon from "../icons/iconComponents/CloseIcon";
import "./NoteView.css";
import ReactDOM from "react-dom";
import {
	Editor,
	EditorState,
	convertToRaw,
	convertFromRaw,
	ContentState
} from "draft-js";
import "draft-js/dist/Draft.css";
import {
	createRefetchContainer,
	createFragmentContainer,
	graphql
} from "react-relay";
// import RichTextEditor from "./RichTextEditor";
import SvgTrash from "../icons/Trash.svg";
import SvgEditNote from "../icons/EditNoteIcon.svg";
import DeleteNoteMutation from "../mutations/DeleteNoteMutation";
import { NoteModal } from "../components/Modal";
import { useTheme } from "../contexts/ThemeContext";

// import loadable from '@loadable/component';
// const RichTextEditor = loadable(() => import('./RichTextEditor'));

function NoteView(props) {
	const [isNoteModalActive, setIsNoteModalActive] = useState(false);
	const [selectedText, setSelectedText] = useState("");
	const [selectedNoteId, setSelectedNoteId] = useState("");
	const [isEdit, setIsEdit] = useState(false);

	const [editorState, setEditorState] = useState(() =>
		EditorState.createEmpty()
	);

	const theme = useTheme();

	const selectedPostId = props.postId;
	const { notes } = props.user_Notes;

	let postIdInt = atob(selectedPostId)
		.split(":")
		.pop();

	// function onDeleteClick(e) {
	// 	// e.preventDefault();
	// 	let value = e.target.dataset.id;
	// 	console.log(value);
	// }

	const onDeleteClick = e => {
		e.preventDefault();
		let noteId = e.target.dataset.id;
		let noteIdInt = atob(noteId)
			.split(":")
			.pop();

		DeleteNoteMutation(selectedPostId, noteId, noteIdInt, () => {
			console.log("Deleted Note!");
		});
	};

	let noteIdInt = null;

	function onEditClick(e) {
		e.preventDefault();
		setIsEdit(true);
		let noteId = e.target.dataset.id;
		noteIdInt = atob(noteId)
			.split(":")
			.pop();

		setSelectedNoteId(noteId);
		setSelectedText(e.target.dataset.note);
		setIsNoteModalActive(true);
	}

	return (
		<div className="note-view-wrapper">
			{notes != null
				? notes.edges.map((edge, key) => (
						<div key={key} className={`note-shell`}>
							<div className="note-view-container">
								<Editor
									editorState={EditorState.createWithContent(
										convertFromRaw(
											JSON.parse(edge.node.note)
										)
									)}
									readOnly={true}
								/>
							</div>
							<div className="note-view-controls">
								<div>
									<img
										height={18}
										onClick={onDeleteClick}
										data-id={edge.node.id}
										src={SvgTrash}
										alt=""
									/>
								</div>
								<div>
									<img
										onClick={onEditClick}
										data-id={edge.node.id}
										data-note={edge.node.note}
										src={SvgEditNote}
										alt=""
									/>{" "}
								</div>
							</div>
						</div>
				  ))
				: null}

			{isNoteModalActive ? (
				<div className="note-container">
					<NoteModal
						title="Note"
						actionButton="Save"
						setIsModalActive={setIsNoteModalActive}
						isModalActive={isNoteModalActive}
						postIdInt={postIdInt}
						jsonContent={selectedText}
						noteId={selectedNoteId}
						isEdit={isEdit}
					/>
				</div>
			) : null}
		</div>
	);
}

export default createFragmentContainer(NoteView, {
	user_Notes: graphql`
		fragment NoteView_user_Notes on UserNode
			@argumentDefinitions(post: { type: "ID" }) {
			notes(post: $post, first: 100)
				@connection(key: "NoteView_notes", filters: []) {
				edges {
					node {
						id
						note
						date_saved
						isNote
					}
				}
			}
		}
	`
});
